import { render, staticRenderFns } from "./wx-declaration.vue?vue&type=template&id=83251e12"
import script from "./wx-declaration.vue?vue&type=script&lang=js"
export * from "./wx-declaration.vue?vue&type=script&lang=js"
import style0 from "./wx-declaration.vue?vue&type=style&index=0&id=83251e12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports